import React from 'react';
import styles from "./AddScreenshotModal.module.css"
import clsx from 'clsx';
import { ScreenshotDataModel } from '../../../../../../chatbot/customerService/components/screenshotSelector/ScreenshotSelector';
import CustomButton, { ButtonType } from '../../../../../../../components/button/CustomButton';
import ScreenshotCard from './components/ScreenshotCard';

interface AddScreenshotModalProps {
    screenshots: ScreenshotDataModel[]
    isOpen?: boolean;
    currentPage: number;
    totalPages: number;
    onNextClicked: () => void;
    onPreviousClicked: () => void;
    onClose?: () => void;
    onClickView?: (screenshot: ScreenshotDataModel) => void;
    onClickSelect?: (screenshot: ScreenshotDataModel) => void;
    onSendClicked?: () => void;
}

const AddScreenshotModal: React.FC<AddScreenshotModalProps> = ({
    screenshots,
    isOpen = false,
    currentPage,
    totalPages,
    onNextClicked,
    onPreviousClicked,
    onClose,
    onClickView,
    onClickSelect,
    onSendClicked }) => {
    if (!isOpen) return null

    return (
        <div className={styles.modalOverlay} >
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div style={{ flex: 1, flexDirection: "row", display: "flex", gap: "16px" }}>
                    </div>
                    <button className={styles.closeButton} onClick={onClose}>
                        ×
                    </button>
                </div>
                <div className={styles.modalBody}>
                    {screenshots && screenshots.map((screenshot, index) => (
                        <ScreenshotCard key={index} size='large' screenshot={screenshot} onClickView={() => { onClickView && onClickView(screenshot) }} onClickSelect={() => { onClickSelect && onClickSelect(screenshot) }} state='normal' />
                    ))}
                </div>
                <div className={styles.modalFooter} >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '16px' }}>
                        <button
                            onClick={onPreviousClicked}
                            disabled={currentPage === 1}>
                            Prev
                        </button>
                        <span>{currentPage} / {totalPages}</span>
                        <button
                            onClick={onNextClicked}
                            disabled={currentPage === totalPages}>
                            Next
                        </button>
                    </div>
                    <div className={styles.buttons}>
                        <button className={clsx(styles.button, styles.warning)} onClick={onClose}>
                            Cancel
                        </button>
                        <CustomButton text='Add' type={ButtonType.Approve} onClick={onSendClicked} />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AddScreenshotModal;